import { createFileRoute } from '@tanstack/react-router'

import {
  CourseDetailsView,
  getCourseQueryOptions
} from '@/modules/coursesManagement'

export const Route = createFileRoute('/_auth/courses-management/$courseId/')({
  component: CourseDetailsView,
  loader: async ({ context, params }) =>
    context.queryClient.ensureQueryData(getCourseQueryOptions(params.courseId))
})
